import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 border-t border-navy-800 py-12 px-4 sm:px-6 lg:px-8 text-center" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <div className="mb-8" data-id="element-130">
          <h3 className="text-2xl font-bold text-gold-400 mb-2" data-id="element-131">
            🌙 MUNDO RECURSOS™
          </h3>
          <p className="text-blue-100/80 max-w-md mx-auto" data-id="element-132">
            El sistema de sueño infantil para padres primerizos con bebés de 0 a
            24 meses.
          </p>
          <p className="text-white font-medium mt-4 italic" data-id="element-133">
            "Porque criar un bebé no debería costarte todas las noches del año."
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-blue-200/70" data-id="element-134">
          <a href="mailto:soportemundorecursos@gmail.com" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-135">
            <Mail className="w-5 h-5" data-id="element-136" /> soportemundorecursos@gmail.com
          </a>
          <a href="https://www.instagram.com/mundorecursos.online/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-137">
            <Instagram className="w-5 h-5" data-id="element-138" /> @mundorecursos.online
          </a>
          <a href="https://www.mundorecursos.store" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-139">
            <Globe className="w-5 h-5" data-id="element-140" /> www.mundorecursos.store
          </a>
        </div>

        <div className="border-t border-navy-800 pt-8 text-sm text-navy-500" data-id="element-141">
          <p className="mb-4" data-id="element-142">
            © Mundo Recursos™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-blue-200/30 italic" data-id="element-143">
            🌙 "La próxima noche puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}